const UserOrganization = async (_, args, context, info) => {
  const url = `${context.url.stargateRoot}/my-orgs`;
  return context.fetch(url).then(data => data.json()).then(res => ({
    cloudId: res.managedBy && res.managedBy.id || null,
    name: res.managedBy && res.managedBy.name || null
  }));
};
export default UserOrganization;